import { useContext, useEffect, useMemo, useState } from "react"
import { ToastContext } from "../../context/ToastContext";
import services from "../../services/services";
import { Urls } from "../../services/Urls";

export const useIntegrateJira = () => {

    const { showInfo, showError, showSuccess } = useContext(ToastContext);
    const [inputValue, setinputValue] = useState('');
    const [profileVisibilityStep, setProfileVisibilityStep] = useState(1);
    const [currStep, setCurrStep] = useState(null);
    const [popupClosed, setPopupClosed] = useState(false);
    const [loader, setLoader] = useState({ val: false, btn: false });

    useEffect(() => {
        getUserProductInfo();
    }, [])

    const getUserProductInfo = async () => {
        try {
            setLoader((prev) => ({ ...prev, val: true }));
            const res = await services.getInvokeRemote("POST", Urls("GETUSERPRODUCTINFO"), {});
            if (!res?.body?.error_status) {
                const data = res?.body?.data?.user_product?.[0];
                if (data?.product_accountId && data?.product_token) {
                    setCurrStep(2);
                } else if (data?.product_accountId && !data?.product_token) {
                    setCurrStep(1);
                } else if (!data?.product_accountId && !data?.product_token && data?.user_code) {
                    setCurrStep(0);
                } else {
                    setCurrStep(-1);
                }
                setLoader((prev) => ({ ...prev, val: false }));
            }
        } catch (error) {
            console.error("Error: ", error);
            setLoader((prev) => ({ ...prev, val: false }));
        }
    }

    const handleUserAccountToken = async () => {
        try {
            if (!inputValue) {
                showInfo('Info', 'Please paste the token');
                return;
            }
            const payload = {
                "account_token": inputValue
            }
            const res = await services.getInvokeRemote('POST', Urls('GETUPSERTUSERACCOUNTTOKEN'), payload)
            if (res.body.StatusCode === 400 || res.body.StatusCode === 204 || res.body.StatusCode === 202 || res.body.StatusCode === 500) {
                showError("Error", res.body.errorMessage);
            }
            else if (res.status === 200) {
                if (res.body.data) {
                    showSuccess("Success", res.body.message);
                    setCurrStep(2);
                    setinputValue("");
                }
            }
        }
        catch (error) {
            console.error('Error :', error);
        }
    }

    const handlePaste = async (e) => {
        const text = await navigator.clipboard.readText();
        setinputValue(text)
    }

    const changeProfileVisibility = (key) => {
        if (key === "visibility") {
            const popup = window.open('https://id.atlassian.com/manage-profile/profile-and-visibility', '_blank', 'width=600,height=500');
            setProfileVisibilityStep(2);

            const popupCheck = setInterval(() => {
                if (popup.closed) {
                    clearInterval(popupCheck);
                    setPopupClosed(true);
                    setProfileVisibilityStep(3);
                }
            }, 500);
        } else if (key === "token") {
            window.open('https://id.atlassian.com/manage-profile/security/api-tokens', '_blank', 'width=600,height=500');
        }
    }

    const handleSaveProfileVisibility = async () => {
        try {
            setLoader((prev) => ({ ...prev, btn: true }));
            const res = await services.getInvokeRemote("GET", Urls("IMPORTJIRAACCOUNTID"));
            if (res?.body.StatusCode === 400 || res?.body.StatusCode === 204 || res?.body.StatusCode === 202 || res?.body.StatusCode === 401 || res?.body.StatusCode === 500) {
                showError('Error', res?.body.errorMessage);
                setCurrStep(0);
                setLoader((prev) => ({ ...prev, btn: false }));
                return;
            } else if (!res?.body?.error_status && res?.body?.data) {
                showSuccess("success", res?.body?.message);
                setCurrStep(1);
                setLoader((prev) => ({ ...prev, btn: false }));
            } else {
                showError("Error", res?.body?.message);
                setCurrStep(0);
                setLoader((prev) => ({ ...prev, btn: false }));
                return;
            }
        } catch (error) {
            console.error("Error: ", error);
            setCurrStep(0);
            setLoader((prev) => ({...prev, btn: false}));
        }
    }

    return useMemo(() => ({
        inputValue, setinputValue, handlePaste, handleUserAccountToken, currStep, setCurrStep, changeProfileVisibility, handleSaveProfileVisibility, profileVisibilityStep, popupClosed, loader
    }), [inputValue, setinputValue, handlePaste, handleUserAccountToken, currStep, setCurrStep, changeProfileVisibility, handleSaveProfileVisibility, profileVisibilityStep, popupClosed, loader])
}